import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-5 tw-pl-5 tw-pt-5 tw-pb-5 mt-3",
  style: {"margin-left":"2rem"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalUsers"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_7 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "modal-dialog" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_13 = { class: "tw-flex tw-gap-3" }
const _hoisted_14 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_16 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_18 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_20 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_35 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_36 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_37 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_38 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenario4",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenario4",
  "aria-hidden": "true"
}
const _hoisted_48 = { class: "modal-dialog" }
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_53 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_55 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_58 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_59 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_60 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_61 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_62 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE LOAN ORIGINATOR")
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM-MLO", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, "NAME-MLO", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL-MLO", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, "PMI", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-D&I", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_77 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_82 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FINANCING INFORMATION")
  ])
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, "DOWN-PAYMENT", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-AMOUNT", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-PROGRAM", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-YEARS", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", null, "PMI-OR-MIP", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-TAXES", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-INSURANCE", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", null, "FEDERAL-TAXES", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", null, "FLOOD-INSURANCE", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", null, "ASSOCIATION PAYMENT", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("td", null, "OTHERS-MONTHLY-PAYMENT", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", null, "TOTAL-ESTIMAL-MONTHLY-PAYMENT $", -1)
const _hoisted_98 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_99 = { class: "modal-dialog" }
const _hoisted_100 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_102 = { class: "modal-body" }
const _hoisted_103 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_105 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_107 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_109 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_110 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_111 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_113 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_114 = ["disabled"]
const _hoisted_115 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, "TOTAL PAYMENTS MONTHLY ", -1)
const _hoisted_117 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_118 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleTotalTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY")
], -1)
const _hoisted_120 = {
  class: "collapse",
  id: "collapseExampleTotalTittle"
}
const _hoisted_121 = { class: "card card-body" }
const _hoisted_122 = { class: "tw-flex tw-justify-around" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample99",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("INSPECTOR")
], -1)
const _hoisted_127 = {
  class: "collapse",
  id: "collapseExample99"
}
const _hoisted_128 = { class: "card card-body" }
const _hoisted_129 = { class: "tw-flex tw-justify-around" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_132 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR", -1)
const _hoisted_134 = { class: "tw-px-4" }
const _hoisted_135 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_136 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROPERTY", -1)
const _hoisted_139 = ["value"]
const _hoisted_140 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_142 = {
  key: 2,
  class: "tw-w-full"
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_145 = ["value"]
const _hoisted_146 = { class: "tw-w-full" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_149 = ["value"]
const _hoisted_150 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_151 = ["disabled"]
const _hoisted_152 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_153 = { class: "tw-w-full table-edit" }
const _hoisted_154 = ["colspan"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_160 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_161 = { key: 0 }
const _hoisted_162 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER", -1)
const _hoisted_164 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_165 = { key: 0 }
const _hoisted_166 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL", -1)
const _hoisted_168 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_169 = { key: 0 }
const _hoisted_170 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_171 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_172 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_173 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE", -1)
const _hoisted_175 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_176 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_177 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_178 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_179 = {
  key: 1,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_180 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI", -1)
const _hoisted_181 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_182 = {
  key: 2,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_183 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO D&I", -1)
const _hoisted_184 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_185 = {
  key: 3,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_186 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO", -1)
const _hoisted_187 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_188 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_189 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_191 = { class: "tw-border-none tw-px-4" }
const _hoisted_192 = ["onClick"]
const _hoisted_193 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER", -1)
const _hoisted_195 = { class: "tw-px-4" }
const _hoisted_196 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_197 = { class: "tw-w-full" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_199 = { class: "tw-w-full" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_201 = { class: "tw-w-full" }
const _hoisted_202 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_203 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION", -1)
const _hoisted_205 = { class: "tw-px-4" }
const _hoisted_206 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_207 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE", -1)
const _hoisted_209 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_210 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT", -1)
const _hoisted_212 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_213 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT", -1)
const _hoisted_215 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_216 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_217 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM", -1)
const _hoisted_218 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_219 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_220 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_221 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_222 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS", -1)
const _hoisted_224 = { class: "tw-tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_225 = {
  key: 1,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_226 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, "PMI ", -1)
const _hoisted_227 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_228 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_230 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_231 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_232 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_233 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_234 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_236 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_237 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_238 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_239 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_240 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_242 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_243 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_244 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_245 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_246 = { class: "tw-flex tw-justify-center" }
const _hoisted_247 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_248 = { class: "tw-flex tw-justify-end" }
const _hoisted_249 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_250 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL ESTIMATED MONTHLY PAYMENT $ ", -1)
const _hoisted_251 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_252 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-fixed tw-top-0 tw-left-0", { 'tw-w-full tw-h-full': _ctx.loaderConfig.isLoading }])
    }, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": !_ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"])
    ], 2),
    (_ctx.header === null)
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial for the use of the ''TOTAL FINANCING MONTHLY PAYMENT''",
          helpVideo: "https://www.realtortools.org/media/VideoTotalFinancialMonthly.mp4"
        }))
      : _createCommentVNode("", true),
    (!_ctx.foreign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ResidentialView, {
            header: false,
            onRealtorEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRealtor($event)))
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.foreign)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("button", _hoisted_4, [
      _createElementVNode("img", {
        class: "tw-w-[40px] tw-mr-3",
        src: require('@/assets/Images/iconos-02.png'),
        alt: ""
      }, null, 8, _hoisted_5),
      _createTextVNode(" RECORD ")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_ctx.scenario.users)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "w-100",
                          range: "",
                          modelValue: _ctx.configDatePicker.date,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                            _ctx.changeDate
                          ],
                          placeholder: "Enter date range..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getScenarioUsers())),
                      class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                    }, "Filter"),
                    _createElementVNode("table", _hoisted_20, [
                      _hoisted_21,
                      (_ctx.scenario.users.results.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal4858",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.loadScenarios(user))
                                  }, _hoisted_25, 8, _hoisted_23)
                                ])
                              ]))
                            }), 256))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_26, _hoisted_28))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    (_ctx.scenario.userScenarios)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("table", _hoisted_38, [
                            _hoisted_39,
                            (_ctx.scenario.userScenarios.results.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("a", {
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#exampleModalEscenario4",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                        }, _hoisted_43, 8, _hoisted_41)
                                      ])
                                    ]))
                                  }), 256))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_44, _hoisted_46))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printScenario())),
                    class: "block"
                  }, [
                    _hoisted_54,
                    _createTextVNode("PRINT")
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateMail()))
                  }, [
                    _hoisted_56,
                    _createTextVNode("SEND")
                  ]),
                  _createVNode(_component_vue3_html2pdf, {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": false,
                    "pdf-quality": 2,
                    "pdf-format": "a4",
                    "pdf-content-width": "800px",
                    "manual-pagination": true,
                    onBeforeDownload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                    ref: "html2Pdf"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_57
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.scenario.scenarioData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("table", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_64,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.selectedProperty.name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_65,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.score), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_66,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.program_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_67,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.selectedYears.name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_68,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.username + " " +
                                                            _ctx.scenario.scenarioData.personal_data.lastname), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_69,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.phonenumber), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_70,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.email), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_71,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.interes_rate), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_72,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.minimum_down_paymentlower), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_73,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.minimum_down_paymenthigher), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_74,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.average_mip_pmi), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_75,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.backend_ratio), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_76,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.maximum_loan), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_79,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_80,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_81,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_82, [
                            _hoisted_83,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_84,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPrice), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_85,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.downPayment), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_86,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.loanAmount), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_87,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.program_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_88,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.interes_rate), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_89,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.selection_data.selectedYears.name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_90,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.pmi), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_91,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyTaxes.text) + "% ", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_92,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyInsurance.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_93,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.stateTaxes.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_94,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyFloodInsurance.text) + "%", 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_95,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.association), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_96,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.otherMontlhyPayment), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_97,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.financial_information.totalEstimalMonthlyPayment
                                                            ?
                                                            _ctx.scenario.scenarioData.financial_information.totalEstimalMonthlyPayment
                                                            : 0), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _hoisted_101,
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _hoisted_104,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _hoisted_106,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "53",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.message]
                ])
              ])
            ]),
            _hoisted_108,
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                (_ctx.scenarioMail.file)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_111, [
                      _hoisted_112,
                      _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  disabled: _ctx.v$.scenarioMail.$invalid,
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
                }, "SEND MESSAGE", 8, _hoisted_114)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_115, [
        _hoisted_116,
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _hoisted_119,
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                      _createTextVNode(),
                      _hoisted_123,
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                        onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                      }, "GET IT", 8, _hoisted_124)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_125, [
            _hoisted_126,
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                      _createTextVNode(),
                      _hoisted_130,
                      _hoisted_131
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_132, [
          _hoisted_133,
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("div", _hoisted_135, [
              (!_ctx.foreign)
                ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                    _hoisted_137,
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.property) = $event))
                    }, [
                      _hoisted_138,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTableProperties, (tabletype) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: tabletype.id
                        }, _toDisplayString(tabletype.name), 9, _hoisted_139))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.filters.property]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.foreign)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                    _hoisted_141,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.score) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.filters.score]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.foreign)
                ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                    _hoisted_143,
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.program) = $event))
                    }, [
                      _hoisted_144,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: program.id
                        }, _toDisplayString(program.name), 9, _hoisted_145))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.filters.program]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_146, [
                _hoisted_147,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters.year) = $event))
                }, [
                  _hoisted_148,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: year.id
                    }, _toDisplayString(year.name), 9, _hoisted_149))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.year]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("button", {
                class: "tw-bg-[#00a0da] disabled:tw-bg-[#ccc] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args))),
                disabled: _ctx.listUserSections.length == 0
              }, "RUN", 8, _hoisted_151)
            ]),
            _createElementVNode("div", _hoisted_152, [
              _createElementVNode("table", _hoisted_153, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                      colspan: _ctx.listUserSections.length + 1
                    }, _hoisted_156, 8, _hoisted_154)
                  ])
                ]),
                (_ctx.listUserSections.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_157, [
                      _createElementVNode("tr", _hoisted_158, [
                        _hoisted_159,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_160, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_161, _toDisplayString(user.username +
                                                " " + user.lastname), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_162, [
                        _hoisted_163,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_164, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(user.phonenumber), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_166, [
                        _hoisted_167,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_168, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_169, _toDisplayString(user.email), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      (!_ctx.foreign)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_170, [
                            _createElementVNode("td", _hoisted_171, _toDisplayString(_ctx.filters.program_name), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                              return (_openBlock(), _createElementBlock("td", _hoisted_172, _toDisplayString(user.fha), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", _hoisted_173, [
                        _hoisted_174,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_175, _toDisplayString(user.interes_rate && user.interes_rate
                                            !=
                                            "-" ? user.interes_rate + "%" : "-"), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_176, [
                        _createElementVNode("td", _hoisted_177, _toDisplayString(_ctx.foreign ? "DOWN PAYMENT" : "MINIMUM DOWN PAYMENT"), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_178, _toDisplayString(user.minimum_down_payment &&
                                            user.minimum_down_payment != "-" ? user.minimum_down_payment + "%" : "-"), 1))
                        }), 256))
                      ]),
                      (!_ctx.foreign)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_179, [
                            _hoisted_180,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                              return (_openBlock(), _createElementBlock("td", _hoisted_181, _toDisplayString(user.average_mip_pmi), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.foreign)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_182, [
                            _hoisted_183,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                              return (_openBlock(), _createElementBlock("td", _hoisted_184, _toDisplayString(user.backend_ratio), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.foreign)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_185, [
                            _hoisted_186,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                              return (_openBlock(), _createElementBlock("td", _hoisted_187, _toDisplayString(user.maximum_loan ? ('' + _ctx.commaFormat(user.maximum_loan)) : ''), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("table", _hoisted_188, [
                _createElementVNode("tr", _hoisted_189, [
                  _hoisted_190,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                    return (_openBlock(), _createElementBlock("td", _hoisted_191, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.loadData(user)),
                        class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                      }, "GET IT", 8, _hoisted_192)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_193, [
          _hoisted_194,
          _createElementVNode("div", _hoisted_195, [
            _createElementVNode("div", _hoisted_196, [
              _createElementVNode("div", _hoisted_197, [
                _hoisted_198,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customer.name) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_199, [
                _hoisted_200,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customer.phone) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_201, [
                _hoisted_202,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customer.email) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.email]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_203, [
          _hoisted_204,
          _createElementVNode("div", _hoisted_205, [
            _createElementVNode("table", _hoisted_206, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_207, [
                  _hoisted_208,
                  _createElementVNode("td", _hoisted_209, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalFinancial",
                      value: _ctx.financialInformation.propertyPrice,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.financialInformation.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_210, [
                  _hoisted_211,
                  _createElementVNode("td", _hoisted_212, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "downPaymentTotalFinancial",
                      value: _ctx.financialInformation.downPayment,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.financialInformation.downPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_213, [
                  _hoisted_214,
                  _createElementVNode("td", _hoisted_215, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "loanAmount",
                      value: _ctx.loanAmount,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.loanAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_216, [
                      _hoisted_217,
                      _createElementVNode("td", _hoisted_218, _toDisplayString(_ctx.selection.selectedProgram ? _ctx.selection.selectedProgram.name : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_219, [
                  _hoisted_220,
                  _createElementVNode("td", _hoisted_221, _toDisplayString(_ctx.selection.selectedUser ? _ctx.selection.selectedUser.interes_rate : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_222, [
                  _hoisted_223,
                  _createElementVNode("td", _hoisted_224, _toDisplayString(_ctx.selection.selectedYears ? _ctx.selection.selectedYears.name : ''), 1)
                ]),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_225, [
                      _hoisted_226,
                      _createElementVNode("td", _hoisted_227, " $ " + _toDisplayString(_ctx.pmi !== null ? Math.round(_ctx.pmi).toLocaleString() : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_228, [
                  _hoisted_229,
                  _createElementVNode("td", _hoisted_230, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "monthlypayment",
                      value: _ctx.propertyTaxes,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.propertyTaxes) = $event)),
                      options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_231, [
                  _hoisted_232,
                  _createElementVNode("td", _hoisted_233, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "monthlypayment",
                      value: _ctx.propertyInsurance,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.propertyInsurance) = $event)),
                      options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_234, [
                  _hoisted_235,
                  _createElementVNode("td", _hoisted_236, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "monthlypayment",
                      value: _ctx.federalTaxes,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.federalTaxes) = $event)),
                      options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_237, [
                  _hoisted_238,
                  _createElementVNode("td", _hoisted_239, _toDisplayString(_ctx.financialInformation.propertyFloodInsurance?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyFloodInsurance?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_240, [
                  _hoisted_241,
                  _createElementVNode("td", _hoisted_242, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "association",
                      value: _ctx.financialInformation.association,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.financialInformation.association) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_243, [
                  _hoisted_244,
                  _createElementVNode("td", _hoisted_245, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "otherMontlhyPayment",
                      value: _ctx.financialInformation.otherMontlhyPayment,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.financialInformation.otherMontlhyPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_246, [
          _createElementVNode("div", _hoisted_247, [
            _createElementVNode("div", _hoisted_248, [
              _createElementVNode("div", _hoisted_249, [
                _hoisted_250,
                _createVNode(_component_VueNumberFormat, {
                  id: "association",
                  value: _ctx.totalMonthly,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.totalMonthly) = $event)),
                  options: {
                                    precision: 0,
                                    prefix: '$ ',
                                    thousand: ',',
                                    acceptNegative: false,
                                    isInteger: false,
                                    decimal: '.',
                                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_251, [
          _createElementVNode("button", {
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitScenario($event))),
            disabled: !_ctx.scenarioValid,
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER", 8, _hoisted_252)
        ])
      ])
    ])
  ]))
}